import TelemetryCharts from "@/components/TelemetryCharts";
import { Field } from "@/components/common";
import { num, fmtTime } from "@/lib/format";
import { History, Lock } from "lucide-react";
import { buildReplayNav, courseLabel } from "@/lib/mapNavigation";

const REPLAY_IMG = "https://images.unsplash.com/photo-1656011196400-2c548b70a981";

export default function ReplayPanel({ mission, points, idx }) {
  const cur = points[idx] || {};
  // MAP.NAV.1 — cap historique uniquement s'il est enregistré ; déplacement dérivé des positions.
  const nav = buildReplayNav(points, idx);
  // chart history with t = index for cursor alignment
  const history = points.map((p, i) => ({
    t: i,
    battery: Number(p.battery) || 0,
    alt: Number(p.alt) || 0,
    speed: Number(p.speed) || 0,
    signal: Number(p.signal) || 0,
  }));

  return (
    <div data-testid="replay-panel" className="h-full flex flex-col bg-[#141414] border-l border-white/10">
      <div className="relative h-24 shrink-0 overflow-hidden border-b border-white/10">
        <img src={REPLAY_IMG} alt="drone" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#141414] to-transparent" />
        <div className="absolute bottom-3 left-4">
          <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#2DD4BF]"><History size={12} /> Relecture post-vol</div>
          <div className="font-chivo text-lg font-black tracking-tighter mt-0.5">{mission?.drone_id} · {mission?.mission_type}</div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        <div data-testid="replay-no-command" className="flex items-center gap-2 font-mono text-[10px] text-[#F59E0B] border border-[#F59E0B]/30 bg-[#F59E0B]/10 rounded-sm px-2 py-1.5">
          <Lock size={12} /> Mode relecture — aucune commande active
        </div>

        {/* Selected point readout */}
        <div className="bg-[#0A0A0A] border border-[#2DD4BF]/30 rounded-sm p-3">
          <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-[#525252] mb-2">Point sélectionné — {fmtTime(cur.timestamp)}</div>
          <div className="grid grid-cols-2 gap-2">
            <Field label="Batterie" value={num(cur.battery, 0)} unit="%" color="#22C55E" />
            <Field label="Altitude" value={num(cur.alt)} unit="m" color="#3B82F6" />
            <Field label="Vitesse" value={num(cur.speed)} unit="m/s" color="#A78BFA" />
            <Field label="Signal" value={num(cur.signal, 0)} unit="%" color="#F59E0B" />
            <Field label="Mode" value={cur.mode || "—"} />
            <Field label="Statut" value={cur.status || "—"} />
            <Field label="Latitude" value={num(cur.lat, 5)} />
            <Field label="Longitude" value={num(cur.lng, 5)} />
            <Field label="Cap" value={nav.headingValid ? `${num(nav.headingDeg, 0)}°` : "non enregistré"} />
            <Field label="Déplacement" value={nav.courseValid ? `${num(nav.courseDeg, 0)}° ${courseLabel(nav)}` : "—"} />
          </div>
        </div>

        <div>
          <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#A3A3A3] mb-2">Graphes synchronisés</div>
          {history.length > 0 ? (
            <TelemetryCharts history={history} cursorT={idx} />
          ) : (
            <div className="font-mono text-[11px] text-[#525252]">Aucune donnée de télémétrie pour cette mission</div>
          )}
        </div>

        <div className="font-mono text-[10px] text-[#525252]">{points.length} points de télémétrie · point {points.length ? idx + 1 : 0}/{points.length}</div>
      </div>
    </div>
  );
}
